import React, { useEffect } from 'react';

// Utils
import { getCurrentMoment, convertMomentToUnix } from 'Shared/utils/DateTime.utils';

// Constants
import { PiAdminConsoleIntroModalData } from './PiAdminConsoleIntroSlides.constants';

// Hooks
import { useToggle } from 'Shared/utils/hooks';
import { useCurrentUser } from 'Shared/utils/hooks/use-current-user';
import { useApp } from 'Shared/utils/hooks/use-app';

// Components
import NewFeatureCarouselModal from '../NewFeatureCarouselModal/NewFeatureCarouselModal';

const PiAdminConsoleIntroModal = () => {
  const [isOpen, toggleIsOpen] = useToggle(false);

  const { updateFlag, getFlag } = useCurrentUser();
  const { isZoom } = useApp();

  const hasSeenFlag = getFlag({ flag: 'seen_pi_admin_console_intro_modal' });

  useEffect(() => {
    if (isOpen) {
      const timestamp = convertMomentToUnix(getCurrentMoment());
      updateFlag({ flag: 'seen_pi_admin_console_intro_modal', value: timestamp });
    }
  }, [isOpen]);

  // we haven't seen the modal, open it
  useEffect(() => {
    if (!isZoom && !hasSeenFlag) toggleIsOpen();
  }, []);

  // do not render the modal if we've seen it, or
  // if this is the first time seeing the modal
  // which will hapen when it's been opened
  if (!isOpen) return null;

  return <NewFeatureCarouselModal isOpen={isOpen} toggleIsOpen={toggleIsOpen} data={PiAdminConsoleIntroModalData} />;
};

export default PiAdminConsoleIntroModal;
